"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseManager = void 0;
var InputUtils_1 = require("./InputUtils");
/**
 * Holds mouse state data.
 */
var MouseManager = /** @class */ (function () {
    function MouseManager(pInteractionManager) {
        this._interactionManager = pInteractionManager;
        this._interactionManager.addListener(InputUtils_1.Events.MOUSE_DOWN, this.onMouseDown, this);
        this._interactionManager.addListener(InputUtils_1.Events.MOUSE_UP, this.onMouseUp, this);
    }
    Object.defineProperty(MouseManager, "mouseDown", {
        /**
         * Is the mouse currently down?
         */
        get: function () {
            return MouseManager._mouseDown;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the mouse down flag to true.
     */
    MouseManager.prototype.onMouseDown = function () {
        MouseManager._mouseDown = true;
    };
    /**
     * Sets the mouse down flag to false.
     */
    MouseManager.prototype.onMouseUp = function () {
        MouseManager._mouseDown = false;
    };
    MouseManager._mouseDown = false;
    return MouseManager;
}());
exports.MouseManager = MouseManager;
//# sourceMappingURL=MouseManager.js.map